import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { X } from "lucide-react";
import { CALENDLY_URL } from "@/lib/site";

const BookingContext = createContext({ openBooking: () => {}, closeBooking: () => {} });

export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openBooking = useCallback(() => setOpen(true), []);
  const closeBooking = useCallback(() => setOpen(false), []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    if (open) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", onKey);
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <BookingContext.Provider value={{ openBooking, closeBooking }}>
      {children}
      {open && (
        <div
          data-testid="booking-modal"
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="absolute inset-0 bg-[#0F172A]/75 backdrop-blur-sm animate-fade-in"
            onClick={closeBooking}
          />
          <div className="relative w-full max-w-3xl bg-white shadow-2xl border border-[#E2E8F0] overflow-hidden animate-fade-up">
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#E2E8F0] bg-[#FDFBF7]">
              <div>
                <p className="eyebrow">Cultural Capital</p>
                <h3 className="font-serif text-xl text-ink">Book a Strategy Call</h3>
              </div>
              <button
                onClick={closeBooking}
                data-testid="booking-modal-close"
                aria-label="Close"
                className="p-2 text-[#64748B] hover:text-ink hover:bg-[#EEF2F6] transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="bg-white">
              <iframe
                title="Schedule with Cultural Capital"
                src={`${CALENDLY_URL}?hide_gdpr_banner=1&background_color=ffffff&text_color=1e293b&primary_color=1c86c4`}
                className="w-full"
                style={{ height: "72vh", minHeight: "560px", border: "0" }}
              />
            </div>
          </div>
        </div>
      )}
    </BookingContext.Provider>
  );
};
